// Menu categorisation used across the dashboard (categories + sub-categories).
export const MENU_CATEGORIES = ["VEG", "NON-VEG", "ADDONS"];
export const MENU_SUBCATEGORIES = ["BURGERS", "WRAPS", "SNACK ATTACK", "POP STARS", "DRINKS"];

export const UNCATEGORIZED = "Uncategorized";
export const OTHER_SUB = "Other";

// Order categories for display: known ones first, then any custom, Uncategorized last.
export function orderCategories(cats) {
  const known = MENU_CATEGORIES.filter((c) => cats.includes(c));
  const custom = cats.filter((c) => c && !MENU_CATEGORIES.includes(c) && c !== UNCATEGORIZED).sort();
  const tail = cats.includes(UNCATEGORIZED) ? [UNCATEGORIZED] : [];
  return [...known, ...custom, ...tail];
}

export function orderSubcategories(subs) {
  const known = MENU_SUBCATEGORIES.filter((s) => subs.includes(s));
  const custom = subs.filter((s) => s && !MENU_SUBCATEGORIES.includes(s) && s !== OTHER_SUB).sort();
  const tail = subs.includes(OTHER_SUB) ? [OTHER_SUB] : [];
  return [...known, ...custom, ...tail];
}

// Group items -> { category: { subcategory: [items] } } preserving display order.
export function groupByCategory(items) {
  const map = new Map();
  for (const it of items) {
    const cat = it.category || UNCATEGORIZED;
    const sub = it.subcategory || OTHER_SUB;
    if (!map.has(cat)) map.set(cat, new Map());
    const subMap = map.get(cat);
    if (!subMap.has(sub)) subMap.set(sub, []);
    subMap.get(sub).push(it);
  }
  return orderCategories([...map.keys()]).map((cat) => {
    const subMap = map.get(cat);
    const subs = orderSubcategories([...subMap.keys()]).map((sub) => ({
      sub,
      items: subMap.get(sub),
    }));
    const count = subs.reduce((n, s) => n + s.items.length, 0);
    return { cat, subs, count };
  });
}
